///
/// EarthBrowser
///
/// Earthquake legend body. Every quake is the one design-system red
/// (DesignColors.MARKER_QUAKE); magnitude is size, recency is motion, and
/// age is the fade - so the legend explains those three rather than a
/// color ramp. Mirrors QuakeMarkerNode.
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

import { LegendFootnote, LegendSection, SymbolRow } from "./LegendPrimitives"

// red-800 at the dome's face-on fill
const cQuakeCss = "rgba(153, 27, 27, 0.85)"
const cQuakeRimCss = "rgb(220, 60, 60)"

// Three magnitudes spanning the marker's exponential size ramp
const cSizeSteps: Array<{ mag: string; px: number }> = [
	{ mag: "M4", px: 5 },
	{ mag: "M6", px: 9 },
	{ mag: "M8", px: 15 },
]

function Dome({ px, pulse = false }: { px: number; pulse?: boolean }) {
	return (
		<span className="relative inline-flex items-center justify-center" style={{ width: px + 6, height: px + 6 }}>
			{pulse && <span className="absolute inset-0 rounded-full border" style={{ borderColor: cQuakeRimCss, opacity: 0.6 }} />}
			<span className="rounded-full" style={{ width: px, height: px, backgroundColor: cQuakeCss, boxShadow: `inset 0 0 0 1px ${cQuakeRimCss}` }} />
		</span>
	)
}

export function EarthquakeLegendContent() {
	return (
		<>
			<div className="space-y-1">
				<div className="text-slate-300">Size · magnitude</div>
				<div className="flex items-end gap-4 px-1">
					{cSizeSteps.map(step => (
						<span key={step.mag} className="flex flex-col items-center gap-1">
							<Dome px={step.px} />
							<span className="text-[10px] text-slate-400">{step.mag}</span>
						</span>
					))}
				</div>
			</div>
			<LegendSection>
				<SymbolRow swatch={<Dome px={7} pulse />}>Pulsing ring · last 2 h, or a USGS alert / tsunami flag</SymbolRow>
				<SymbolRow swatch={<Dome px={7} />}>Older quakes sit still and fade out</SymbolRow>
			</LegendSection>
			<LegendFootnote>
				USGS feed. Fade lasts about 12 h for M4, 2 days for M6, 10 days for M8+; scrubbing the timeline replays each quake.
			</LegendFootnote>
		</>
	)
}
